import { translateObjectData } from '../../utils/locale';
import { generateEventId, urlify } from '../../utils/string';

const listAnalytics = (items, indexes, setup, currentView) => {
	if (typeof window === 'undefined') return;
	if (typeof window.dataLayer === 'undefined') window.dataLayer = [];
	const uniqueEventID = generateEventId();

	window.dataLayer.push({ ecommerce: null });
	window.dataLayer.push({
		event: 'view_item_list',
		ecommerce: {
			'x-fb-event_id': uniqueEventID,
			item_list_id: urlify(currentView),
			item_list_name: currentView,
			items: items.map((item, i) => {
				const localizedItem = translateObjectData(setup, item);
				const itemCategory = localizedItem.canonicalUri.split('/').slice(0, -1).reduce((acc, category, j) => ({ ...acc, [`item_category${j > 0 ? j + 1 : ''}`]: category }), {});
				return {
					item_name: localizedItem.name,
					item_id: item.groupId,
					price: localizedItem.price.priceAsNumber,
					currency: setup.countries[setup.country].currency,
					item_brand: localizedItem.brand,
					...itemCategory,
					item_variant: localizedItem.variantName,
					item_list_id: urlify(currentView),
					item_list_name: currentView,
					index: indexes[i] || 0,
					quantity: '1',
				};
			}),
		},
	});
};

export default listAnalytics;
